import React from 'react';
import { useNavigate } from 'react-router-dom';

import AssistanceCard from './components/AssistanceCard';
import InstructionCard from './components/InstructionCard';
import { themes } from 'kb-shared';
import { typography } from 'styled/shared';
import styled from 'styled-components';

import medications from './medications';

const {
  serif: {
    page: { H1 }
  },
  sans: {
    copy: { Large }
  }
} = typography;
const { queries } = themes;

const Container = styled.div`
  ${({ theme }) => theme.grid.pageContainer};
  margin-top: 100px;
  display: flex;
  flex-direction: column;
`;

const Title = styled(H1)`
  margin-bottom: 20px;
`;

const RowContainer = styled.div`
  display: grid;
  grid-gap: 20px 20px;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-template-areas: '. . .' '. . .';
  margin-top: 30px;

  @media ${queries.maxTablet} {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    grid-template-areas: '. .' '. .' 'assistance assistance';

    > div {
      grid-area: assistance;
    }
  }

  @media ${queries.mobile} {
    display: flex;
    flex-direction: column;

    > button,
    > div {
      margin-bottom: 20px;
    }

    > div {
      margin-top: 20px;
    }
  }
`;

const MedicationInstructions = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Title>Injection Tutorials</Title>
      <Large>
        Select a tutorial that corresponds to the medication(s) you have been prescribed:
      </Large>
      <RowContainer>
        {medications.map((med, i) => {
          return (
            <InstructionCard
              key={`tutorial-card-${med.id}`}
              instruction={med}
              onClick={() => {
                navigate(
                  `/medication-instruction?med_index=${i}&medication_name=${med.displayName}`
                );
              }}
            />
          );
        })}
        <AssistanceCard />
      </RowContainer>
    </Container>
  );
};

export default MedicationInstructions;
